import styled from 'styled-components';
import { ToggleButtonGroup } from '@mui/material';

import colors from '../../../styles/colors';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  width: fit-content;

  .MuiToggleButton-root {
    text-transform: none;
    font-size: 13px;
    padding: 5px 18px;
    color: ${colors.shades.secondary8};
    border-color: ${colors.shades.secondary4};

    &.Mui-selected {
      background-color: ${colors.shades.secondary3};
      color: ${colors.base.alpha};
      border-color: ${colors.shades.secondary3};

      &:hover {
        background-color: ${colors.shades.secondary8};
      }
    }
  }
`;

export {
  StyledToggleButtonGroup,
};
